var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeMobileGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 3H8C7.6023 3.0004 7.221 3.15856 6.93978 3.43978C6.65856 3.721 6.5004 4.1023 6.5 4.5V21C6.50046 21.3977 6.65864 21.7789 6.93984 22.0602C7.22105 22.3414 7.60232 22.4995 8 22.5H17C17.3977 22.4995 17.7789 22.3413 18.0601 22.0601C18.3413 21.7789 18.4995 21.3977 18.5 21V4.5C18.4995 4.10232 18.3414 3.72105 18.0602 3.43984C17.779 3.15864 17.3977 3.00046 17 3ZM17 4.5V6H8V4.5H17ZM8 21V7.5H17V21H8Z",
    fill: "#171719"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMobileGray);
export default __webpack_public_path__ + "static/media/home-mobile_gray.83a2f8c974b06f9827d660d24e52a3a1.svg";
export { ForwardRef as ReactComponent };